import Vue from 'vue';
import Router from 'vue-router';
import SalaDisputa from '@/components/SalaDisputa';
import LoteAberto from '@/components/LoteAberto';
import MeusLotes from '@/components/MeusLotes';
import Busca from '@/components/Busca';
import Teste from '@/components/Teste';
import Telao from "@/components/Telao.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/teste',
      name: 'Teste',
      component: Teste
    },
    {
      path: '/leilao/index/leilao_id/:id',
      name: 'SalaDisputa',
      prosp: true,
      component: SalaDisputa
    },
    {
      path: '/leilao/index/telao/leilao_id/:id',
      name: 'telao',
      prosp: true,
      component: Telao
    },
    {
      path: '/leilao/index/leilao_id/:id/lote/:idlote',
      props: true,
      name: 'LoteAberto',
      component: LoteAberto,
      beforeEnter: (to, from, next) => {
          window.previous_page = from
          next()
      }
    },
    {
      path: '/leilao/index/leilao_id/:id/meuslotes',
      props: true,
      name: 'MeusLotes',
      component: MeusLotes
    },
    {
      path: '/leilao/index/busca/pesquisa',
      props: true,
      name: 'Busca',
      component: Busca
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js